function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M35.4 0v283.5H248V0H35.4zm184.1 28.5v70.9H63.8V28.5h155.7zM63.8 255V113.9h155.7V255H63.8zm49.7-127.3H85.2v28.2h28.3v-28.2zm42.3 0h-28.2v28.2h28.2v-28.2zm42.6 0h-28.2v28.2h28.2v-28.2zm0-85h-14.1v42.5h14.1V42.7zm-28.3 0h-14.2v42.5h14.2V42.7zm-56.6 127.5H85.2v28.3h28.3v-28.3zm42.3 0h-28.2v28.3h28.2v-28.3zm42.6 0h-28.2v28.3h28.2v-28.3zm-84.9 42.4H85.2v28.2h28.3v-28.2zm42.3 0h-28.2v28.2h28.2v-28.2zm42.6 0h-28.2v28.2h28.2v-28.2z"
})));